<template>
<div >

<div class="contenttopbar grid px-3 mt-1">

<div class="col-9 md:col-6">
<h3 class="text-primary mb-3 mt-3 font-medium">{{title}}</h3>
</div>

<div class="col-3 md:col-6">
<div class="flex align-items-center justify-content-end">
<div class="hide_on_mobile "><Button type="button" class="p-button-info p-button-outlined p-button-sm mt-2 mr-2" :label="$store.state.languages.lang_phrases.duzenle" icon="pi pi-pencil" @click="gotoEdit" /></div>
<div class="hide_on_mobile "><Button type="button" class="p-button-help p-button-outlined p-button-sm mt-2 mr-2" :label="$store.state.languages.lang_phrases.excel_rapor_indir" icon="pi pi-download" @click="downloadExcel" :loading="preparing_excel" /></div>
<div class="hide_on_mobile "><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.geri_don" icon="pi pi-arrow-left" @click="goBack" /></div>

<div class="show_on_mobile"><Button type="button" class="p-button-info p-button-outlined p-button-sm mt-2 mr-2" icon="pi pi-pencil" @click="gotoEdit" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-help p-button-outlined p-button-sm mt-2 mr-2" icon="pi pi-download" @click="downloadExcel" :loading="preparing_excel" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" icon="pi pi-arrow-left" @click="goBack" /></div>
</div>
</div>

</div>

 <div class="mt-4" >
  <template v-if="report">
    <template v-if="!report.is_uptodate">
      <div class="flex align-items-center justify-content-center mb-8 mt-8">
      <h3 class="text-primary font-medium">Rapor verisi güncelleniyor. Lütfen daha sonra tekrar deneyin.</h3>
    </div>
    </template>
    <template v-else>
      <AnalyticsListOutput v-if="display_type=='list'" @updateRequestFilters="updateRequestFilters"></AnalyticsListOutput>
      <AnalyticsGroupOutput v-if="display_type=='group'"></AnalyticsGroupOutput>
    </template>
  </template>
  

 </div>



</div>	
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from "moment"
let boolean_statuses = [          
          {name:"Açık",id:1},
          {name:"Kapalı",id:0},
        ]
export default {

  name: 'QuestionlistSameTypeCalculation',

  data () {
    return {
      loading:true,
      report:null,
      preparing_excel:false,
      display_type:"list",
      report_for_download:null,
      request_filters:[],
    }
  },
  computed:{
    title()
    {
      if(this.report)
      {
        if(this.report.translations.length)
        {
          let translation = this.report.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
          if(translation)
          {
            return translation.translation
          }
          return this.report.name
        }
        return this.report.name
      }
      return ""
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    updateRequestFilters(data)
    {
      console.log("updateRequestFilters")
      console.log(data)
      this.request_filters = data
    },
    async prepareColumns()
    {
      let columns = this.report_for_download.columns
      for(let column of columns)
      {        
        
        let filteroptions = JSON.parse(column.filteroptions)
        column.filteroptions = JSON.parse(column.filteroptions)
        if(filteroptions)
        {
            //project_status
            
            if(filteroptions.type=="project_status" || filteroptions.type=="flow_status")
            {
                         
              column.filterselectors = []

              let phrases  = ["olusturuldu","goruntulendi","baslandi","tamamlandi0","degerlendirmede","iptal_edildi","duzeltme_talebi_incelemede"]
              for(let phrase of phrases)
              {
                let the_translation = await this.generalApiGetWithoutLoader("language/get_item_translation/"+phrase)
                let obj = {
                    name:the_translation.original,
                    id:null,
                    translations:the_translation.translations
                  }
                if(phrase=="olusturuldu")
                {
                  obj.id = "created"
                }
                if(phrase=="goruntulendi")
                {
                  obj.id = "viewed"
                }
                if(phrase=="baslandi")
                {
                  obj.id = "started"
                }
                if(phrase=="tamamlandi0")
                {
                  obj.id = "finished"
                }
                if(phrase=="degerlendirmede")
                {
                  obj.id = "under_review"
                }
                if(phrase=="iptal_edildi")
                {
                  obj.id = "canceled"
                }
                if(phrase=="duzeltme_talebi_incelemede")
                {
                  obj.id = "correction_requested"
                }
                column.filterselectors.push(obj)

              }
              
            }
            //project_status
            //verification_status
            if(filteroptions.type=="verification_status" || filteroptions.type=="audit_status")
            {
                         
              column.filterselectors = []

              let phrases  = ["olusturuldu","tamamlandi0","degerlendirmede","iptal_edildi","planlandi","tekrar_planlandi","muaf"]
              for(let phrase of phrases)
              {
                let the_translation = await this.generalApiGetWithoutLoader("language/get_item_translation/"+phrase)
                let obj = {
                    name:the_translation.original,
                    id:null,
                    translations:the_translation.translations
                  }
                if(phrase=="olusturuldu")
                {
                  obj.id = "created"
                }
                if(phrase=="planlandi")
                {
                  obj.id = "scheduled"
                }
                if(phrase=="tekrar_planlandi")
                {
                  obj.id = "rescheduled"
                }
                if(phrase=="tamamlandi0")
                {
                  obj.id = "finished"
                }
                if(phrase=="degerlendirmede")
                {
                  obj.id = "under_review"
                }
                if(phrase=="iptal_edildi")
                {
                  obj.id = "canceled"
                }
                if(phrase=="muaf")
                {
                  obj.id = "exempt"
                }
                column.filterselectors.push(obj)

              }
              
            }
            //verification_status
            //custom_attribute
            if(filteroptions.type=="custom_attribute")
            {
               
              let custom_attribute = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+column.relateditem_id)

              if(custom_attribute)
              {
                column.customattribute = custom_attribute
                column.filteroptions.attribute_type = custom_attribute.type
                //select
                if(custom_attribute.type=="select")
                {
                 
                   let custom_attribute_options = await this.generalApiGetWithoutLoader("custom_attributes/options/"+column.relateditem_id)
                   if(custom_attribute_options.length)
                   {
                    column.filterselectors = custom_attribute_options
                   }

                }
                //select
                //boolean
                if(custom_attribute.type=="boolean")
                {
                  column.filterselectors = this.sanitizeArray(boolean_statuses)
                }
                //boolean
                if(custom_attribute.type=="number")
                {
                }
                //boolean
                //boolean
                if(custom_attribute.type=="categorised" || custom_attribute.type=="cascadecategorised")
                {
                   let custom_attribute_options = await this.generalApiGetWithoutLoader("custom_attributes/categories/"+column.relateditem_id)
                   if(custom_attribute_options.length)
                   {
                    column.filterselectors = custom_attribute_options
                   }
                }
                //boolean

              }

            }
            //custom_attribute
            //numerical
            if(filteroptions.type=="questionlist_points" ||filteroptions.type=="questionlist_nonconformity_count"||filteroptions.type=="section_points" || filteroptions.type=="inputfield_point" || filteroptions.type=="questionlist_nonconformity_count" || filteroptions.type=="questionlist_custom_points")
            {
              
            }
            //numerical
            //inputfield_null_reason
            if(filteroptions.type=="inputfield_null_reason")
            {

              let the_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+column.relateditem_id)
              column.filterselectors = await this.generalApiGetWithoutLoader("questionlistnullreasons/"+the_inputfield.questionlist_id)
              
              
              
            }
            //inputfield_null_reason
            //inputfield_submission
            if(filteroptions.type=="inputfield_submission")
            {
              
              let the_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+column.relateditem_id)
              /////////////
              if(the_inputfield.type=="select" || the_inputfield.type=="multiselect" || the_inputfield.type == "listselect")
              {

                  

                column.filteroptions.filtertype = the_inputfield.type

                if(the_inputfield.questionlist.type=="same_question_pattern")
                {
                  column.filterselectors = await this.generalApiGetWithoutLoader("questionlists/inputfield/options_for_same_type_pattern/"+column.relateditem_id)
                }
                else
                {
                  column.filterselectors = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+column.relateditem_id)
                }
              }
              /////////////
              if(the_inputfield.type=="columns")
              {

                let inputfield_column = await this.generalApiGetWithoutLoader("questionlists/inputfield/column/"+filteroptions.column_id)
                if(inputfield_column.type=="select")
                {
                  column.filteroptions.filtertype = "select"

                  

                  column.filterselectors = inputfield_column.options
                }
                if(inputfield_column.type=="number" || inputfield_column.type=="custom")
                {
                  column.filteroptions.filtertype = "number"
                  
                }
                if(inputfield_column.type=="text")
                {
                  column.filteroptions.filtertype = "text"
                  
                }
              }
              /////////////
              if(the_inputfield.type=="number")
              {
                column.filteroptions.filtertype = "number"
                
              }
              if(the_inputfield.type=="location")
              {
                
                column.filteroptions.filtertype = "location"
                
              }
              /////////////
              if(the_inputfield.type=="text" || the_inputfield.type=="longtext")
              {
                column.filteroptions.filtertype = "text"
                
              }
              
            }
            //inputfield_submission

            

        }
        
        if(column.sortable===1)
        {
          column.sortable = true
        }
        else
        {
          column.sortable = false
        }

        if(column.filterable===1)
        {
          column.filterable = true
        }
        else
        {
          column.filterable = false
        }
      }
      this.report_for_download.columns = columns
    },
    getTitleTranslation(id)
    {
      let column = this.report_for_download.columns.find((item)=>{return item.id == id})
      let translation = column.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      if(translation)
      {
        return translation.translation
      }
      else
      {       
        return column.name
      }
    },
    getCellOutput(data,column)
    {
      
      console.log("getCellOutput")
      console.log(data)
      console.log(column)
      
      if(data === undefined)
      {        
        return "-"
      }
      if(typeof data === 'undefined')
      {        
        return "-"
      }
      if(data === void 0)
      {        
        return "-"
      }
      if(data === "-")
      {        
        return "-"
      }
      if(data || data===0)
      {   
        if(!column.filteroptions)
        {
          return data
        }
        //custom_attribute  
        if(column.filteroptions.type=="custom_attribute")
        {
          
          if(column.customattribute)
          {
            if(column.customattribute.type=="select"
              ||column.customattribute.type=="boolean"
              ||column.customattribute.type=="categorised"
              ||column.customattribute.type=="cascadecategorised")
            {
              let option = column.filterselectors.find(item=>item.id == data)
              if(option)
              {
                return this.getTheTranslation(option,"translation")
              }
            }
            else
            {
              return data
            }
          }
          else
          {
            return "-"
          }
        }
        //custom_attribute
        //numerical  
        if(column.filteroptions.type=="questionlist_nonconformity_count" 
          || column.filteroptions.type=="section_nonconformities" 
          || column.filteroptions.type=="inputfield_nonconformity_count"
          || column.filteroptions.type=="verification_auditor"
          || column.filteroptions.type=="audit_auditor"
          || column.filteroptions.type=="supplier_location"
          || column.filteroptions.type=="supplier_users"
          || column.filteroptions.type=="last_supplier_conversation" )
        {
          return data
        }
        //numerical 
        //numerical  
        if(column.filteroptions.type=="questionlist_points" 
          || column.filteroptions.type=="questionlist_custom_points" 
          || column.filteroptions.type=="section_points" 
          || column.filteroptions.type=="inputfield_point" )
        {
          
          
          return parseFloat(data.toFixed(3))
        }
        //numerical 
        //date  
        if(column.filteroptions.type=="verification_date" 
          || column.filteroptions.type=="audit_date" )
        {
          return this.$filters.momentFormat( data," Do-MM-YYYY")
        }
        //date 
        //project_status  
        if(column.filteroptions.type=="project_status" || column.filteroptions.type=="flow_status" || column.filteroptions.type=="verification_status" || column.filteroptions.type=="audit_status")
        {
          let option = column.filterselectors.find(item=>item.id == data)
          if(option)
          {
            return this.getTheTranslation(option,"translation")
          }
        }
        //project_status  
        //inputfield_null_reason  
        if(column.filteroptions.type=="inputfield_null_reason")
        {
          let option = column.filterselectors.find(item=>item.id == data)
          if(option)
          {
            return this.getTheTranslation(option,"translation")
          }
        }
        //inputfield_null_reason
        //inputfield_submission  
        if(column.filteroptions.type=="inputfield_submission")
        {
          
          //has options
          if(column.filterselectors)
          {
            //select
            if(column.filteroptions.filtertype=="select")
            {
              let option = column.filterselectors.find(item=>item.id == data)
              if(option)
              {
                return this.getTheTranslation(option,"translation")
              }
              else
              {
                return parseFloat(data.toFixed(3))
              }
            }
            //select
            //multiselect
            else if(column.filteroptions.filtertype=="multiselect" || column.filteroptions.filtertype=="listselect")
            {
              let selections = JSON.parse(data)
              let options = []
              for(let selection of selections)
              {
                let option = column.filterselectors.find(item=>item.id == selection)
                if(option)
                {
                  options.push(this.getTheTranslation(option,"translation"))
                }
              }
              
              if(options.length>2)
              {
                let tooltiptext = ""
                {
                  for (let i = 0; i < options.length; i++) 
                  {
                    if(i==options.length)
                    {
                      tooltiptext = tooltiptext+options[i]
                    }
                    else
                    {
                      tooltiptext = tooltiptext+options[i]+'\r\n'
                    }
                  }
                }
                
                return  tooltiptext
              }
              else
              {
                return  options[0]
              }              
            }
            //multiselect
            //listselect
            //none
            else
            {
              return parseFloat(data.toFixed(3))
            }
            
          }
          //has options
          else
          {
            if(column.filteroptions.filtertype=="text" || column.filteroptions.filtertype=="longtext" || column.filteroptions.filtertype=="location")
            {
              return data
            }
            else
            {
              return parseFloat(data.toFixed(3))
            }
            
          }
          
        }
        //inputfield_submission
        }
        return "-"
    },
    getCellValue(data)
    {
      
      if(data)
      {
        if(data.textval)
        {
          return data.textval
        }
        if(data.dateval)
        {
          return data.dateval
        }
        if(data.numericalval)
        {
          return data.numericalval
        }
        if(data.numericalval===0)
        {        
          return data.numericalval
        }
      }
      else
      {
        return null
      }
      
    },
    sortFilters()
    {
      let filters = this.sanitizeArray(this.request_filters)
      let arr = []
      for(let filter in filters)
      {
        let filter_name = filter
        let filter_obj = filters[filter]
        /*
        console.log("filter_obj")
        console.log(filter_obj)
        console.log(filter)
        */
        if(filter=="name" && filter_obj.value)
        {          
          let obj = {
            id:filter_name,
            type:"name",
            value:filter_obj.value
          }
          arr.push(obj)
        }
        if(filter=="suppliercode" && filter_obj.value)
        {          
          let obj = {
            id:filter_name,
            type:"suppliercode",
            value:filter_obj.value
          }
          arr.push(obj)
        }
        let type = filter_obj.filtertype
        let obj = {
          id:filter_name,
          type:type,
        }
        ////////////
        if(type=="project_status"
          ||type=="flow_status"
          ||type=="verification_status"
          ||type=="audit_status"
          ||type=="inputfield_null_reason")
        {
          
          if(filter_obj.value && filter_obj.value.length)
          {
            let elements = filter_obj.value.map(item=>item.id)
            obj.ids = elements
            arr.push(obj)
          }          
        }
        ////////////
        if(type=="custom_attribute")
        {
          if(filter_obj.attribute_type=="select"
            ||filter_obj.attribute_type=="boolean"
            ||filter_obj.attribute_type=="categorised"
            ||filter_obj.attribute_type=="cascadecategorised")
          {
            if(filter_obj.value && filter_obj.value.length)
            {
              let elements = filter_obj.value.map(item=>item.id)
              obj.ids = elements
              arr.push(obj)
            } 

          }
          if(filter_obj.attribute_type=="number")
          {
            if(filter_obj.value && filter_obj.value.length)
            {
              if(filter_obj.value[1] || filter_obj.value[0])
              {
                obj.max = filter_obj.value[1]
                obj.min = filter_obj.value[0]
                arr.push(obj)
              }
            }
          }
        }
        ////////////
        if(type=="supplier_location"
          ||type=="supplier_users"
          ||type=="last_supplier_conversation"
          ||type=="inputfield_nonconformity_count"
          ||type=="verification_auditor"
          ||type=="audit_auditor")
        {

        }
        ////////////
        if(type=="verification_date"
          ||type=="audit_date")
        {

          if(filter_obj.value && filter_obj.value.length)
            {
              if(filter_obj.value[1] || filter_obj.value[0])
              {
                obj.max = filter_obj.value[1]
                obj.min = filter_obj.value[0]
                arr.push(obj)
              }
            }
        }
        ////////////
        ////////////
        if(type=="questionlist_points"||type=="questionlist_custom_points"||type=="questionlist_nonconformity_count"||type=="section_points"||type=="section_nonconformities"||type=="inputfield_point")
        {
          if(filter_obj.value && filter_obj.value.length)
          {
            if(filter_obj.value[1] || filter_obj.value[0])
            {
              obj.max = filter_obj.value[1]
              obj.min = filter_obj.value[0]
              arr.push(obj)
            }
          }
        }
        ////////////
        if(type=="inputfield_submission")
        {
          if(filter_obj.value && filter_obj.value.length)
          {
            if(filter_obj.object_type)
            {

              if(filter_obj.object_type=="select")
              {
                let elements = filter_obj.value.map(item=>item)
                obj.ids = elements
                arr.push(obj)
              }
              ////////////
              if(filter_obj.object_type=="number")
              {
                if(filter_obj.value[1] || filter_obj.value[0])
                {
                  obj.max = filter_obj.value[1]
                  obj.min = filter_obj.value[0]
                  arr.push(obj)
                }
              }
              ////////////
              if(filter_obj.object_type=="text")
              {
                if(filter_obj.value)
                {
                  obj.searchterm = filter_obj.value
                  arr.push(obj)
                }
              }
            }
            
          }
        }
        
      }
      let name_val = arr.find(item=>item.type=="name")
      let code_val = arr.find(item=>item.type=="suppliercode")
      if(name_val && code_val)
      {

      }
      return arr
    },
    async downloadExcel()
    {
      this.preparing_excel = true
      this.report_for_download = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.$route.params.report_id)     
      await this.prepareColumns()
      let filters = JSON.stringify(this.sortFilters())
      let listitems = await this.generalApiGetWithoutLoader("brand_all_report_data/"+this.$route.params.report_id+"?filters="+filters)
      let sheet = []
      let row = await [
      this.$store.state.languages.lang_phrases.tedarikci_ismi,
      this.$store.state.languages.lang_phrases.tedarikci_kodu,
      ]
      //handle column names
      let column_count = 0
      for(let column of this.report_for_download.columns)
      {
        await row.push(this.getTitleTranslation(column.id))  
        column_count++    
      }
      await sheet.push(row)
      //handle column names
      
      column_count = 0
      for(let listitem of listitems)
      {
        if(listitem.supplier && listitem.supplier.name && listitem.supplier.suppliercode)
        {
          let row2 =  []
          row2.push(listitem.supplier.name)
          row2.push(listitem.supplier.suppliercode) 
          for(let brandreportitem of listitem.brandreportitems)
          {
            let cellvalue = this.getCellValue(brandreportitem)
            let column = this.report_for_download.columns.find(item=>item.id == brandreportitem.brandreportcolumn_id)
            row2.push(this.getCellOutput(cellvalue,column))
          }
          
          column_count++ 
          await sheet.push(row2)

        }
        
      }
      
      

      let ws = await XLSX.utils.json_to_sheet(sheet)
      let wb = await XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(wb,ws,this.$store.state.languages.lang_phrases.marka_raporu)
      await XLSX.writeFile(wb,this.report.name+".xls")
      this.preparing_excel = false

    },
    async getData()
    {
      this.loading  = true
      let report = await this.generalApiGetWithoutLoader("brand_report_status/"+this.$route.params.report_id)
      
      let theschema = JSON.parse(report.theschema)
      let output = theschema.nodes.find((element)=>{return element.key=="outputs"})
      this.display_type = output.type
      this.report = report
      //console.log(this.report)
      this.loading  = false
    },
    goBack()
    {
      this.$router.push({ name: "BrandReports"})
    },
    gotoEdit()
    {
      this.$router.push({ name: "BrandReportEdit"})
    },
  }
}
</script>

<style lang="css" scoped>
</style>